type IntegrationModalParams = {
	name: string | number;
	type: string;
	integrationId: string | number | null;
	objectId?: string | number | null;
	frameless?: boolean;
	fullscreen: boolean;
};

export const openIntegrationModal = (params: IntegrationModalParams) => Tools.$upModal.open('integrationModal', params);
